// libs
import React from 'react';
import BaseSwitch, { SwitchProps } from '@mui/material/Switch';
import c from 'classnames';

// styles
import { switchStyles } from './styles';
// utils
import { SIZE_CLASSES } from './utils';

type Props = Omit<SwitchProps, 'size'> & { size?: 'large' | 'medium' | 'small' };

const Switch = React.forwardRef<HTMLButtonElement, Props>((props, ref) => {
  const { className, size = 'medium', ...rest } = props;
  const classes = SIZE_CLASSES[size];

  return (
    <BaseSwitch
      ref={ref}
      className={c(switchStyles, className)}
      classes={classes}
      color="default"
      {...rest}
    />
  );
});

export default React.memo(Switch);
